import request from '@/utils/httpClient'
import { OrderCreateParams, OrderUpdateParams } from '@/types/domain/order'

// 创建订单
export function createOrder(data: OrderCreateParams) {
  return request({
    url: 'order',
    method: 'POST',
    data
  })
}

// 更新订单
export function updateOrder(id: number, data: OrderUpdateParams) {
  return request({
    url: `order/${id}`,
    method: 'put',
    data
  })
}

// 提交审批
export function commitReview(id: number, data?: object) {
  return request({
    url: `order/${id}/actions/commit`,
    method: 'put',
    data
  })
}

// 获取审批列表
export function getReviewList(params?: object) {
  return request({
    url: 'order/review/page',
    method: 'get',
    params
  })
}

// 获取修改审批信息
export function reviewDetailById(id: number) {
  return request({
    url: `order/review/${id}`,
    method: 'get'
  })
}

// 通过审批
export function reviewApprove(id: number, data?: object) {
  return request({
    url: `order/${id}/actions/review/approve`,
    method: 'put',
    data
  })
}

// 通过拒绝
export function reviewReject(id: number, data?: object) {
  return request({
    url: `order/${id}/actions/review/reject`,
    method: 'put',
    data
  })
}

// 生成正式订单
export function regularOrder(id: number, data?: object) {
  return request({
    url: `order/${id}/actions/review/regular`,
    method: 'put',
    data
  })
}
